// extracted by mini-css-extract-plugin
export default {"themeSwitcher":"ThemeSwitcher_themeSwitcher__WVYyT"};